import React, { useState, useEffect } from 'react';
import { Row, Col, Typography, Button, message, Upload, Form, notification, Space } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { UploadOutlined } from '@ant-design/icons';
import { fetchLeadDetailsServices } from '../../auth/slice/authSlice';
import { useParams } from 'react-router-dom';
import { deleteDocuments, uploadCustomerDocumentsService } from '../../../services/admin-services';
import { API_RESPONSE_CODES } from '../../../utills/constant';

const { Title } = Typography;

const LeadDocuments = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const leadDetailsData = useSelector((state) => state?.auth?.leadDetails);
    const isAdmin = useSelector((state) => state?.auth?.isAdmin);
    const permissions = useSelector((state) => state?.auth?.userData?.permissions);
  const roleType = useSelector((state) => state?.auth?.userData?.role);

    const permissionToEdit = isAdmin || permissions?.includes('edit-lead');

    const [isEditMode, setIsEditMode] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [customerFileList, setCustomerFileList] = useState({
        aadhar_card: [],
        pan_card: [],
        bank_statement: [],
        form_16: [],
        other: [],
    });
const isViewOnlyRole =
    roleType === "Procurement Manager" ||
    roleType === "Exchange Evaluation Team";

    const isLeadConverted = leadDetailsData?.lead_status?.name === 'Converted';
    const isLeadCancelledOrRefunded =
        leadDetailsData?.lead_status?.name === 'Cancelled';

    useEffect(() => {
        if (leadDetailsData?.documents) {
            console.log('Lead Documents Data:', leadDetailsData.documents);
            const formattedCustomerFiles = {
                aadhar_card: [],
                pan_card: [],
                bank_statement: [],
                form_16: [],
                other: [],
            };

            leadDetailsData.documents.forEach((doc) => {
                const file = {
                    uid: doc.id,
                    name: doc.document_file_name,
                    status: 'done',
                    url: doc.document_path,
                    document_type: doc.document_type,
                };

                switch (doc.document_type) {
                    case 'Aadhar Card':
                        formattedCustomerFiles.aadhar_card.push(file);
                        break;
                    case 'Pan Card':
                        formattedCustomerFiles.pan_card.push(file);
                        break;
                    case 'Bank Statement':
                        formattedCustomerFiles.bank_statement.push(file);
                        break;
                    case 'Form 16':
                        formattedCustomerFiles.form_16.push(file);
                        break;
                    case 'Other':
                        formattedCustomerFiles.other.push(file);
                        break;
                    default:
                        break;
                }
            });
            setCustomerFileList(formattedCustomerFiles);
        }
    }, [leadDetailsData]);

    const validateCustomerFile = (file) => {
        const isValidType = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif' || file.type === 'application/pdf';
        if (!isValidType) {
            message.error('You can only upload JPG/PNG/GIF/PDF file');
            return Upload.LIST_IGNORE;
        }

        const isLt10M = file.size / 1024 / 1024 < 10;
        if (!isLt10M) {
            message.error('File must be smaller than 10MB');
            return Upload.LIST_IGNORE;
        }

        return true;
    };

    const handleCustomerFileChange = (info, field) => {
        let newFileList = [...info.fileList];
        setCustomerFileList((prev) => ({
            ...prev,
            [field]: newFileList,
        }));
    };

    const handleRemoveCustomerDocument = async (file, fieldName) => {
        if (!file.originFileObj) {
            // Existing file from server - delete via API
            try {
                const documentId = file?.uid;
                const reqData = {
                    document_id: documentId ? documentId : null,
                    document_type: '',
                    lead_id: id,
                };

                if (leadDetailsData?.documents) {
                    const response = await deleteDocuments(reqData);
                    message.success(response?.data?.message || 'File removed successfully');
                    setCustomerFileList({
                        ...customerFileList,
                        [fieldName]: customerFileList[fieldName]?.filter((item) => item.uid !== file.uid),
                    });
                    dispatch(fetchLeadDetailsServices({ id: id }));
                } else {
                    message.error(`Failed to remove file. No document ID available.`);
                }
            } catch (error) {
                message.error(`Failed to remove file: ${error.message}`);
            }
        } else {
            // Remove new file that hasn't been uploaded yet
            setCustomerFileList({
                ...customerFileList,
                [fieldName]: customerFileList[fieldName]?.filter((item) => item.uid !== file.uid),
            });
        }
    };

    const handleSave = async () => {
        try {
            setIsLoading(true);
            const formData = new FormData();
            formData.append('lead_id', id);

            // Append customer files to the formData as arrays: key[0], key[1], ...
            Object.keys(customerFileList).forEach((key) => {
                if (customerFileList[key]?.length > 0) {
                    customerFileList[key].forEach((file, index) => {
                        if (file.originFileObj) {
                            const arrayKey = `${key}[${index}]`;
                            formData.append(arrayKey, file.originFileObj);
                        }
                    });
                }
            });

            const res = await uploadCustomerDocumentsService(formData);
            if (res.data.status === API_RESPONSE_CODES.OK || res.data.status === API_RESPONSE_CODES.CREATED) {
                notification.success({
                    message: res.data.message,
                });
                setIsEditMode(false);
                dispatch(fetchLeadDetailsServices({ id: id }));
            }
        } catch (error) {
            notification.error({
                description: error.response?.data?.message ?? error?.message,
                style: {
                    width: 400,
                },
            });
        } finally {
            setIsLoading(false);
        }
    };

    const handleCancel = () => {
        setIsEditMode(false);
        // Reset file list to original state from redux
        dispatch(fetchLeadDetailsServices({ id: id }));
    };
    console.log(permissionToEdit && !isLeadConverted && !isLeadCancelledOrRefunded
    )
    return (
        <div className='user-data lead-detail'>
            <div className='user-table-head'>
                <div className='personal-detail'>
                    <div className='d-flex justify-content-between align-items-center'>
                        <div className='user-left text-start'>
                            <Title level={4} className=''>
                                Customer&apos;s Files
                            </Title>
                        </div>
                        {!isLeadConverted && !isLeadCancelledOrRefunded && !isEditMode && !isViewOnlyRole && (
                            <div className='user-right'>
                                <Button type='primary' className='secondary-button' onClick={() => setIsEditMode(true)}>
                                    Edit
                                </Button>
                            </div>
                        )}
                    </div>
                    <div className='detail-wrapper pt-2'>
                        {isEditMode ? (
                            <Form layout='vertical'>
                                <Row gutter={[16, 16]} align='middle'>
                                    <Col xl={8} md={12} sm={24} xs={24}>
                                        <Form.Item label="Aadhar Card" className='mb-0'>
                                            <div className='exchange-upload d-flex justify-content-between align-items-baseline'>
                                                <Upload
                                                    showUploadList={{ showRemoveIcon: true }}
                                                    customRequest={({ onSuccess }) => onSuccess('ok')}
                                                    onChange={(info) => handleCustomerFileChange(info, 'aadhar_card')}
                                                    beforeUpload={validateCustomerFile}
                                                    multiple={true}
                                                    maxCount={5}
                                                    accept='.jpg,.jpeg,.png,.gif,.pdf'
                                                    fileList={customerFileList?.aadhar_card}
                                                    onRemove={(file) => handleRemoveCustomerDocument(file, 'aadhar_card')}
                                                >
                                                    <Button icon={<UploadOutlined />}></Button>
                                                </Upload>
                                            </div>
                                        </Form.Item>
                                    </Col>
                                    <Col xl={8} md={12} sm={24} xs={24}>
                                        <Form.Item label="PAN Card" className='mb-0'>
                                            <div className='exchange-upload d-flex justify-content-between align-items-baseline'>
                                                <Upload
                                                    showUploadList={{ showRemoveIcon: true }}
                                                    customRequest={({ onSuccess }) => onSuccess('ok')}
                                                    onChange={(info) => handleCustomerFileChange(info, 'pan_card')}
                                                    beforeUpload={validateCustomerFile}
                                                    multiple={true}
                                                    maxCount={5}
                                                    accept='.jpg,.jpeg,.png,.gif,.pdf'
                                                    fileList={customerFileList?.pan_card}
                                                    onRemove={(file) => handleRemoveCustomerDocument(file, 'pan_card')}
                                                >
                                                    <Button icon={<UploadOutlined />}></Button>
                                                </Upload>
                                            </div>
                                        </Form.Item>
                                    </Col>
                                    <Col xl={8} md={12} sm={24} xs={24}>
                                        <Form.Item label="Bank Statement" className='mb-0'>
                                            <div className='exchange-upload d-flex justify-content-between align-items-baseline'>
                                                <Upload
                                                    showUploadList={{ showRemoveIcon: true }}
                                                    customRequest={({ onSuccess }) => onSuccess('ok')}
                                                    onChange={(info) => handleCustomerFileChange(info, 'bank_statement')}
                                                    beforeUpload={validateCustomerFile}
                                                    multiple={true}
                                                    maxCount={5}
                                                    accept='.jpg,.jpeg,.png,.gif,.pdf'
                                                    fileList={customerFileList?.bank_statement}
                                                    onRemove={(file) => handleRemoveCustomerDocument(file, 'bank_statement')}
                                                >
                                                    <Button icon={<UploadOutlined />}></Button>
                                                </Upload>
                                            </div>
                                        </Form.Item>
                                    </Col>
                                    <Col xl={8} md={12} sm={24} xs={24}>
                                        <Form.Item label="Form 16" className='mb-0'>
                                            <div className='exchange-upload d-flex justify-content-between align-items-baseline'>
                                                <Upload
                                                    showUploadList={{ showRemoveIcon: true }}
                                                    customRequest={({ onSuccess }) => onSuccess('ok')}
                                                    onChange={(info) => handleCustomerFileChange(info, 'form_16')}
                                                    beforeUpload={validateCustomerFile}
                                                    multiple={true}
                                                    maxCount={5}
                                                    accept='.jpg,.jpeg,.png,.gif,.pdf'
                                                    fileList={customerFileList?.form_16}
                                                    onRemove={(file) => handleRemoveCustomerDocument(file, 'form_16')}
                                                >
                                                    <Button icon={<UploadOutlined />}></Button>
                                                </Upload>
                                            </div>
                                        </Form.Item>
                                    </Col>
                                    <Col xl={8} md={12} sm={24} xs={24}>
                                        <Form.Item label="Other" className='mb-0'>
                                            <div className='exchange-upload d-flex justify-content-between align-items-baseline'>
                                                <Upload
                                                    showUploadList={{ showRemoveIcon: true }}
                                                    customRequest={({ onSuccess }) => onSuccess('ok')}
                                                    onChange={(info) => handleCustomerFileChange(info, 'other')}
                                                    beforeUpload={validateCustomerFile}
                                                    multiple={true}
                                                    maxCount={5}
                                                    accept='.jpg,.jpeg,.png,.gif,.pdf'
                                                    fileList={customerFileList?.other}
                                                    onRemove={(file) => handleRemoveCustomerDocument(file, 'other')}
                                                >
                                                    <Button icon={<UploadOutlined />}></Button>
                                                </Upload>
                                            </div>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        ) : (
                            <Row gutter={20} justify='start'>
                                <Col xl={12} lg={12} md={24} sm={24} xs={24}>
                                    <div className='view-fields d-flex align-items-baseline'>
                                        <h6 className='label'>Aadhar Card:</h6>
                                        <div className='value'>
                                            {leadDetailsData?.documents?.filter(
                                                (doc) => doc.document_type === "Aadhar Card"
                                            )?.length > 0 ? (
                                                leadDetailsData?.documents
                                                    ?.filter((doc) => doc.document_type === "Aadhar Card")
                                                    .map((doc, index) => (
                                                        <a
                                                            key={index}
                                                            href={doc.document_path}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            style={{ display: "block", color: "#1890ff", textDecoration: "underline" }}
                                                        >
                                                            {doc.document_file_name}
                                                        </a>
                                                    ))
                                            ) : (
                                                <span>-</span>
                                            )}

                                        </div>
                                    </div>
                                </Col>

                                <Col xl={12} lg={12} md={24} sm={24} xs={24}>
                                    <div className='view-fields d-flex align-items-baseline'>
                                        <h6 className='label'>PAN Card:</h6>
                                        <div className='value'>
                                            {leadDetailsData?.documents?.filter((doc) => doc.document_type === 'Pan Card')?.length >
                                                0 ? (
                                                leadDetailsData?.documents
                                                    ?.filter((doc) => doc.document_type === 'Pan Card')
                                                    .map((doc, index) => (
                                                        <a
                                                            key={index}
                                                            href={doc.document_path}
                                                            target='_blank'
                                                            rel='noopener noreferrer'
                                                            style={{ display: 'block', color: '#1890ff', textDecoration: 'underline' }}
                                                        >
                                                            {doc.document_file_name}
                                                        </a>
                                                    ))
                                            ) : (
                                                <span>-</span>
                                            )}
                                        </div>
                                    </div>
                                </Col>

                                <Col xl={12} lg={12} md={24} sm={24} xs={24}>
                                    <div className='view-fields d-flex align-items-baseline'>
                                        <h6 className='label'>Form 16:</h6>
                                        <div className='value'>
                                            {leadDetailsData?.documents?.filter((doc) => doc.document_type === 'Form 16')?.length >
                                                0 ? (
                                                leadDetailsData?.documents
                                                    ?.filter((doc) => doc.document_type === 'Form 16')
                                                    .map((doc, index) => (
                                                        <a
                                                            key={index}
                                                            href={doc.document_path}
                                                            target='_blank'
                                                            rel='noopener noreferrer'
                                                            style={{ display: 'block', color: '#1890ff', textDecoration: 'underline' }}
                                                        >
                                                            {doc.document_file_name}
                                                        </a>
                                                    ))
                                            ) : (
                                                <span>-</span>
                                            )}
                                        </div>
                                    </div>
                                </Col>

                                <Col xl={12} lg={12} md={24} sm={24} xs={24}>
                                    <div className='view-fields d-flex align-items-baseline'>
                                        <h6 className='label'>Bank Statement:</h6>
                                        <div className='value'>
                                            {leadDetailsData?.documents?.filter((doc) => doc.document_type === 'Bank Statement')
                                                ?.length > 0 ? (
                                                leadDetailsData?.documents
                                                    ?.filter((doc) => doc.document_type === 'Bank Statement')
                                                    .map((doc, index) => (
                                                        <a
                                                            key={index}
                                                            href={doc.document_path}
                                                            target='_blank'
                                                            rel='noopener noreferrer'
                                                            style={{ display: 'block', color: '#1890ff', textDecoration: 'underline' }}
                                                        >
                                                            {doc.document_file_name}
                                                        </a>
                                                    ))
                                            ) : (
                                                <span>-</span>
                                            )}
                                        </div>
                                    </div>
                                </Col>

                                <Col xl={12} lg={12} md={24} sm={24} xs={24}>
                                    <div className='view-fields d-flex align-items-baseline'>
                                        <h6 className='label'>Other:</h6>
                                        <div className='value'>
                                            {leadDetailsData?.documents?.filter((doc) => doc.document_type === 'Other')?.length >
                                                0 ? (
                                                leadDetailsData?.documents
                                                    ?.filter((doc) => doc.document_type === 'Other')
                                                    .map((doc, index) => (
                                                        <a
                                                            key={index}
                                                            href={doc.document_path}
                                                            target='_blank'
                                                            rel='noopener noreferrer'
                                                            style={{ display: 'block', color: '#1890ff', textDecoration: 'underline' }}
                                                        >
                                                            {doc.document_file_name}
                                                        </a>
                                                    ))
                                            ) : (
                                                <span>-</span>
                                            )}
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        )}
                    </div>
                    {isEditMode && (
                        <div className='user-right d-flex align-items-center justify-content-end mt-4'>
                            <Space size='middle'>
                                <Button type='primary' ghost danger className='primary-button' onClick={handleCancel}>
                                    Cancel
                                </Button>
                                <Button type='primary' className='secondary-button' onClick={handleSave} loading={isLoading}>
                                    Save
                                </Button>
                            </Space>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default LeadDocuments;
